import styled from 'styled-components'
import { respondTo } from '../../styles/_respondTo'

export const FooterContainer = styled.div`
  border-top: 1px solid rgb(92, 96, 105);
  padding: 0 20px;
`

export const Heart = styled.img`
  width: 20px;
  height: 20px;
  margin: 0 5px;
`

export const TextP = styled.p`
  color: ${props => props.color || '#000000'};
  font-size: ${props => props.fontSize || '1rem'};
  display: flex;
  justify-content: center;

  ${respondTo.lg`
  font-size: 1.2rem;
  `}

  ${respondTo.xl`
  font-size: 1.2rem;
  `}
`